const { hash } = window.location;
const hashValues = {};
hash.replace(/^#\/?|\/$/g, '').split('&').forEach((pair) => {
  const [key, value] = pair.split('=');
  hashValues[key] = value;
});

let zoom = 17;
let lat = 37.53668110395066;
let lng = -77.38776039797814;
if (hashValues.loc) {
  ([zoom, lat, lng] = hashValues.loc.split('/').map(str => parseFloat(str)));
}

export default {
  selectedGravestone: (hashValues.selectedGravestone) ? parseInt(hashValues.selectedGravestone, 10) : null,
  gravestones: [],
  zoom,
  center: [lat, lng],
  bounds: [
    [
      37.53959224331248,
      -77.38536715507509
    ],
    [
      37.53376455436679,
      -77.39015221595766
    ]
  ],
  aboutOpen: false,
  contactUsOpen: false,
  userLocation: null,
  hillshadeOn: false,
};



// WEBPACK FOOTER //
// ./src/store/initialState.js